import { makeAttributeList, ShapeStore } from "../ShapeStore";
import { ShapeTranslatable2 } from "../types/Shape";
import { ShapeDOMRepresentation } from "../types/ShapeDOMRepresentation";
import { Verb } from "../types/Verb";
import { SingleOperation } from "./Operation";
import { Selection } from "../selection/Selection";
import { DrawingInterface } from "../DrawingInterface";

export interface SelectToolInterface {
  selections: Selection[];
  replaceSelections(newSelections: ShapeDOMRepresentation[]): void;
}

export class CopyShapesOperation extends SingleOperation {
  private originalSelections: string[];
  constructor(
    private prototypes: [string, ShapeTranslatable2][],
    private selectTool: SelectToolInterface,
    private drawing: DrawingInterface
  ) {
    super(
      prototypes.map(([subjectID, shapePrototype]) => {
        return {
          verb: Verb.UpsertSubjectAttributeMany,
          subjectID,
          version: -1,
          attributes: makeAttributeList({
            ...shapePrototype,
            translate: [
              shapePrototype.translate[0] + 10,
              shapePrototype.translate[1] + 10,
            ],
          }),
        };
      }),
      prototypes.map(([subjectID]) => {
        return {
          verb: Verb.DeleteShape,
          subjectID,
        };
      })
    );
    this.originalSelections = selectTool.selections.map((s) => s.shapeDR.id);
  }

  applyForward(shapeStore: ShapeStore) {
    super.applyForward(shapeStore);
    this.selectTool.replaceSelections(
      this.prototypes.map(([id]) => {
        return this.drawing.indexedShapes[id];
      })
    );
  }

  applyBackward(shapeStore: ShapeStore) {
    super.applyBackward(shapeStore);
    this.selectTool.replaceSelections(
      this.originalSelections.map((id) => {
        return this.drawing.indexedShapes[id];
      })
    );
  }

  get label(): string {
    return `Copy ${this.prototypes.length} shapes`;
  }
}
